<template>        
    <formPasswordValidation :forgottenPass="forgottenPass"/>    
</template>
  
  <script>
  import formPasswordValidation from './components/form_password_validation_component.vue';
  
  export default {
    name: 'PasswordValidation',
    components: {
        formPasswordValidation,
    },
    props: {
    forgottenPass: {
      required: true,
      type: Boolean
    },
  },
  }
  </script>
  
  <style lang="css" scoped>
  
  </style>

  